module.exports = __webpack_public_path__ + "static/media/bg.87b3670.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/bg.mp4
// module id = 56jl
// module chunks = 0